import React from "react";
import {Linking, Platform, StyleSheet, TouchableOpacity, View} from "react-native";
import PtText from "../core/pt-text/pt-text";
import {getTranslation} from "../../helpers/getTranslation";
import {styleVars} from "../../app-style-vars";
import getConfig from "../../environment";
import {getSubdomain} from "../../helpers/getSubdomain";

const hybrisBase = getConfig()?.hybrisBaseUrl.replace(/{subdomain}/g, getSubdomain());
const privacyPolicyUrl = `${hybrisBase}/privacy`;


export default function PtPrivacyPolicy(props) {

  const useInternalPage = props.useInternalLink || false;

  const openPrivacyPolicy = () => {
    if(useInternalPage) {
      props.navigation.navigate('PrivacyPolicy');
    } else {
      if(Platform.OS === 'web') {
        window.open(privacyPolicyUrl)
      } else {
        Linking.openURL(privacyPolicyUrl);
      }
    }
  };

  return (
    <View style={styles.footerLinkContainer}>
      <TouchableOpacity onPress={() => openPrivacyPolicy()}>
        <PtText style={styles.footerLinkText}>{getTranslation('footer.privacy.policy.link.text')}</PtText>
      </TouchableOpacity>
    </View>
  )
}

const styles = StyleSheet.create({
  footerLinkContainer: {
    paddingHorizontal: styleVars.rem(1),
    paddingVertical: styleVars.rem(.5),
    marginBottom: styleVars.rem(.5),
  },
  footerLinkText: {
    fontSize: styleVars.rem(.875),
    color: styleVars.boschDarkBlue,
  },
});
